exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".perf-tool .recButton{padding:1em;width:8px;height:8px;border-radius:50%;outline:none;border:1px solid #ddd;text-align:left;cursor:pointer}.perf-tool .recButton.active{border:1px solid red;background-color:red;box-shadow:0 0 10px red}.perf-tool .x-button{display:block;width:1em;height:1em;border:none;outline:none;padding:0;background-color:transparent;font-size:30px;line-height:1;color:#5a5a5a;cursor:pointer}.perf-tool .removeMeasurement{position:absolute;right:0;top:.2em;transition:all .2s ease-out}.perf-tool .removeMeasurement:hover{-webkit-transform:scale(1.3);transition:all .2s ease-out}.perf-tool .toggleButton{position:absolute;top:-1px;right:0;z-index:500}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/button.css
 ** module id = 206
 ** module chunks = 0
 **/